import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_TIME_ZONE, TIME_ZONE_COOKIE, normalizeTimeZone } from "@/shared/time/zone";

interface TimeZoneContextValue {
  timeZone: string;
}

const TimeZoneContext = createContext<TimeZoneContextValue | null>(null);

export function TimeZoneProvider({ children }: { children: React.ReactNode }) {
  const [timeZone, setTimeZoneState] = useState<string>(DEFAULT_TIME_ZONE);

  useEffect(() => {
    const remembered = readTimeZoneCookie();
    if (remembered) setTimeZoneState(normalizeTimeZone(remembered));
  }, []);

  const value = useMemo<TimeZoneContextValue>(() => ({ timeZone }), [timeZone]);

  return <TimeZoneContext.Provider value={value}>{children}</TimeZoneContext.Provider>;
}

export function useTimeZone(): string {
  return useContext(TimeZoneContext)?.timeZone ?? DEFAULT_TIME_ZONE;
}

function readTimeZoneCookie(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${TIME_ZONE_COOKIE}=([^;]*)`));
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}
